/**
 * Class name that uses to mark tags that are generated by ng-doc and should be styled
 */
export const NG_DOC_ELEMENT: string = 'ngde';
